<template>
    <div class="container">
          <div>
              <span class="title">UploadMachine</span>
          </div>
          <div class="content">
              <span class="title2">请上传机器码文件TXT</span>
              <el-upload
                  action=""
                  class="upload-demo"
                  ref="upload"
                  :on-change="handleChange"
                  :auto-upload="false"
                  :limit="1">
                  <el-button type="primary" >上传文件</el-button>
              </el-upload>
          </div>
    </div>
  </template>
  
  <script>
  export default {
      data(){
          return{
              fileList:[]
          }
      },
      methods:{
          handleChange(file) {
              let reader = new FileReader();   //先new 一个读文件的对象 FileReader
              if (typeof FileReader === "undefined") {  //用来判断你的浏览器是否支持 FileReader
                  this.$message({
                      type: "info",
                      message: "您的浏览器不支持文件读取。"
                  });
                  return;
              }
              reader.readAsText(file.raw, "UTF-8");  //读.txt文件
              let that =this
              reader.onload = function (e) {
                  // let ints = e.target.result.reading({encode: 'GBK'});
                  let content = e.target.result;
                  console.log("读取的内容如下：");
                  console.log(content);
                  if(content){
                      localStorage.setItem('MachineCodeMZ',content)
                      that.$message({
                      type: "success",
                      message: "成功添加机器码"
                  });
                      that.$router.push('/login');
                  }
              };
          },
      }
  }
  </script>
  
  <style scoped>
  .container {
    padding-top: 0mm;
    /* width: 100%; */
    min-height: 700px;
    background-color: #f4f4f4;
    display: flex;
    flex-flow: column;
    /* align-items: center; */
    padding-left: 140px;
  }
  .title{
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #000000;
    font-size: 26px;
    padding-top: 20px;
    /* padding-left: 50px; */
    display: flex;
    flex-direction: row;
  }
  .title2{
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #000000;
    font-size: 20px;
    padding-top: 20px;
    /* padding-left: 50px; */
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
  }
  .content{
      margin-top: 20px;
      margin-left: 60px;
  }
  .upload-demo{
      margin-top: 20px;
  }
  </style>


// WEBPACK FOOTER //
// UploadMachineCode.vue?65c38f51